// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"91":"2a484dc4","249":"09aa7005","325":"969b63bd","435":"7f867dd2","646":"4cb6e64d","787":"e2cb9745"}[chunkId] + ".chunk.js";
};